function Title() {
  return (
    <div className="bg-green-200">
      <h2 className="text-lg font-bold">Weather map</h2>
      <p className="text-sm">選択した地点の現在の天気を表示します</p>
    </div>
  )
}

export default Title;